export default __webpack_public_path__ + "static/media/forestly-noexpl-05_DE.22759043.png";